import { Icon } from "@iconify/react/dist/iconify.js";
import clsx from "clsx";
import { useState } from "react";

/**
 * A component that represents the support floating button when the logged in user is agent.
 *
 * @returns {JSX.Element}
 */

const FloatingSupportList = ({ data }) => {
  const [showIcons, setShowIcons] = useState(false);
  const toggleIcons = () => {
    setShowIcons(!showIcons);
  };

  if (!data) return null;

  return (
    <div className="z-40">
      <button
        onClick={toggleIcons}
        className="fixed z-40 bottom-5 right-5 p-4 rounded-full shadow-lg transition bg-background_steel_blue text-text_white border border-text_white"
      >
        <Icon
          icon="streamline:customer-support-1"
          className="text-text_white text-3xl"
        />
      </button>

      <div
        className={clsx(
          "fixed right-7 flex flex-col items-center gap-3 transition-all duration-300",
          {
            "bottom-[100px]": showIcons,
            "bottom-5": !showIcons,
          }
        )}
      >
        {showIcons && (
          <>
            <a
              className="p-3 rounded-full bg-green-500 shadow-lg bg-background_steel_blue border border-text_white"
              href={data.chat}
              target="_blank"
              rel="noreferrer"
            >
              <Icon
                icon="ri:whatsapp-fill"
                className="text-text_white text-xl"
              />
            </a>
            <a
              className="p-3 rounded-full bg-blue-500 shadow-lg bg-background_steel_blue border border-text_white"
              href={`mailto:${data.email}`}
            >
              <Icon
                icon="bi:envelope-fill"
                className="text-text_white text-xl"
              />
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default FloatingSupportList;
